import React from "react";
import { withRouter } from "react-router-dom";
import Authenticated from "../Utils/Authenticated";
import { auth } from "../Utils/firebase.auth";

import AuthLogo from "../img/user-logo.svg";
import "../styles/Menu.css";

const authStyle = {
  display: "flex",
  position: "fixed",
  right: "25px",
  width: "30px",
  height: "30px",
  cursor: "pointer"
};

function logout() {
  return auth.signOut();
}

function login(history) {
  return history.push("/login");
}

const Auth = ({ history }) => (
  <Authenticated
    renderTrue={(user) => (
      <div
        className="bm-item"
        onClick={() => logout().then(() => history.push("/"))}
        style={{ marginTop: "-50px" }}
      >
        Déconnexion
      </div>
    )}
    renderFalse={() => (
      <div style={authStyle} onClick={() => login(history)}>
        <p style={{ color: "white", marginLeft: "-90px", marginRight: "10px" }}>
          Connexion
        </p>
        <img src={AuthLogo} alt="login" title="Se connecter" style={{marginTop: "10px"}} />
      </div>
    )}
    renderPending={() => null}
  />
);

export default withRouter(Auth);
